import React, { useEffect } from "react";
import { addToList } from "../features/todo/TodoSlice";
import { useDispatch } from "react-redux";
import todoCollection from "../firebase-config";
import { getDocs } from "firebase/firestore";
import BlockAllTodo from "./BlockAllTodo";

const AllTodosKeep = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const gettodos = async () => {
      const data = await getDocs(todoCollection);
      let tempTodo = data.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
      dispatch(addToList(tempTodo));
    };
    gettodos();
  }, []);
  return <BlockAllTodo />;
};

export default AllTodosKeep;
